/** @file Trig wrappers so a deterministic polynomial can replace Math.* if goldens need bit-exactness. */

export const trig = {
  /** Math.sin */
  sin(rad: number): number {
    return Math.sin(rad);
  },
  /** Math.cos */
  cos(rad: number): number {
    return Math.cos(rad);
  },
  /** Math.atan2 */
  atan2(y: number, x: number): number {
    return Math.atan2(y, x);
  },
  /**
   * sqrt(x² + y²) without Math.hypot's per-call argument array: Infinity over NaN, then the sum of squares scaled by
   * the larger magnitude, which is the double V8's Math.hypot returns for two arguments (its Kahan compensation is 0
   * for two terms; the test checks it bit for bit). core/ik/elbowScan keeps an inline copy of this formula.
   */
  hypot(x: number, y: number): number {
    const ax = Math.abs(x);
    const ay = Math.abs(y);
    if (ax === Number.POSITIVE_INFINITY || ay === Number.POSITIVE_INFINITY) return Number.POSITIVE_INFINITY;
    if (Number.isNaN(ax) || Number.isNaN(ay)) return Number.NaN;
    const max = ax > ay ? ax : ay;
    if (max === 0) return 0;
    const sx = ax / max;
    const sy = ay / max;
    return Math.sqrt(sx * sx + sy * sy) * max;
  },
};
